/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseEntity } from '../models/BaseResponseEntity';
import type { ChangePinCodeDto } from '../models/ChangePinCodeDto';
import type { ChangePinCodeEntity } from '../models/ChangePinCodeEntity';
import type { CheckPhoneNumberEntity } from '../models/CheckPhoneNumberEntity';
import type { CheckPinCodeDto } from '../models/CheckPinCodeDto';
import type { CheckPinCodeEntity } from '../models/CheckPinCodeEntity';
import type { CreatePinCodeDto } from '../models/CreatePinCodeDto';
import type { CreatePinCodeEntity } from '../models/CreatePinCodeEntity';
import type { GetAdminPermissionsEntity } from '../models/GetAdminPermissionsEntity';
import type { GetMyRefferals } from '../models/GetMyRefferals';
import type { GetUserPermissionsEntity } from '../models/GetUserPermissionsEntity';
import type { GetUserSettingsEntity } from '../models/GetUserSettingsEntity';
import type { LoginDto } from '../models/LoginDto';
import type { LoginEntity } from '../models/LoginEntity';
import type { LogoutUserEntity } from '../models/LogoutUserEntity';
import type { ProfileUserEntity } from '../models/ProfileUserEntity';
import type { ResetPasswordByEmailEntity } from '../models/ResetPasswordByEmailEntity';
import type { ResetPasswordByUserEmailDto } from '../models/ResetPasswordByUserEmailDto';
import type { SendOtpByEmailDto } from '../models/SendOtpByEmailDto';
import type { SendOtpByEmailEntity } from '../models/SendOtpByEmailEntity';
import type { SubmitReferralDto } from '../models/SubmitReferralDto';
import type { UpdateProfileUserDto } from '../models/UpdateProfileUserDto';
import type { UpdateProfileUserEntity } from '../models/UpdateProfileUserEntity';
import type { UpdateUserSettingsDto } from '../models/UpdateUserSettingsDto';
import type { VerifyOtpByEmailDto } from '../models/VerifyOtpByEmailDto';
import type { VerifyOtpByEmailEntity } from '../models/VerifyOtpByEmailEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserWalletAuthService {

    /**
     * @param phoneNumber
     * @returns CheckPhoneNumberEntity
     * @throws ApiError
     */
    public static authControllerCheckPhoneNumber(
        phoneNumber: string,
    ): CancelablePromise<CheckPhoneNumberEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/check-phone-number/{phoneNumber}',
            path: {
                'phoneNumber': phoneNumber,
            },
        });
    }

    /**
     * @param requestBody
     * @returns CreatePinCodeEntity
     * @throws ApiError
     */
    public static authControllerCreatePinCode(
        requestBody: CreatePinCodeDto,
    ): CancelablePromise<CreatePinCodeEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/create-pin-code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns ChangePinCodeEntity
     * @throws ApiError
     */
    public static authControllerChangePinCode(
        requestBody: ChangePinCodeDto,
    ): CancelablePromise<ChangePinCodeEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/change-pin-code',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Check user' pin code
     * @param requestBody
     * @returns CheckPinCodeEntity
     * @throws ApiError
     */
    public static authControllerCheckPinCode(
        requestBody: CheckPinCodeDto,
    ): CancelablePromise<CheckPinCodeEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/check-pin-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns LoginEntity
     * @throws ApiError
     */
    public static authControllerLogin(
        requestBody: LoginDto,
    ): CancelablePromise<LoginEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get user' profile
     * @returns ProfileUserEntity
     * @throws ApiError
     */
    public static authControllerGetProfileUser(): CancelablePromise<ProfileUserEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/profile',
            errors: {
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update user' profile
     * @param requestBody
     * @returns UpdateProfileUserEntity
     * @throws ApiError
     */
    public static authControllerUpdateProfile(
        requestBody: UpdateProfileUserDto,
    ): CancelablePromise<UpdateProfileUserEntity> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/user-wallet/auth/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @returns LogoutUserEntity
     * @throws ApiError
     */
    public static authControllerLogout(): CancelablePromise<LogoutUserEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/logout',
        });
    }

    /**
     * @param requestBody
     * @returns SendOtpByEmailEntity
     * @throws ApiError
     */
    public static authControllerSendOtpByEmail(
        requestBody: SendOtpByEmailDto,
    ): CancelablePromise<SendOtpByEmailEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/send-otp-by-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns VerifyOtpByEmailEntity
     * @throws ApiError
     */
    public static authControllerVerifyOtpByEmail(
        requestBody: VerifyOtpByEmailDto,
    ): CancelablePromise<VerifyOtpByEmailEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/verify-otp-by-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns ResetPasswordByEmailEntity
     * @throws ApiError
     */
    public static authControllerResetPinCodeByEmail(
        requestBody: ResetPasswordByUserEmailDto,
    ): CancelablePromise<ResetPasswordByEmailEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/reset-pin-code-by-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns GetMyRefferals List of users referred by current user
     * @throws ApiError
     */
    public static authControllerGetMyReferrals(): CancelablePromise<GetMyRefferals> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/my-referrals',
        });
    }

    /**
     * @param requestBody
     * @returns BaseResponseEntity Referral ID updated successfully
     * @throws ApiError
     */
    public static authControllerSubmitReferralId(
        requestBody: SubmitReferralDto,
    ): CancelablePromise<BaseResponseEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user-wallet/auth/submit-referral',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid referral ID or already set`,
            },
        });
    }

    /**
     * @returns GetUserSettingsEntity Get user settings
     * @throws ApiError
     */
    public static authControllerGetUserSettings(): CancelablePromise<GetUserSettingsEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/settings',
        });
    }

    /**
     * @param requestBody
     * @returns GetUserSettingsEntity Update user settings
     * @throws ApiError
     */
    public static authControllerUpdateUserSettings(
        requestBody: UpdateUserSettingsDto,
    ): CancelablePromise<GetUserSettingsEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/user-wallet/auth/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns GetUserPermissionsEntity Get current user admin actions
     * @throws ApiError
     */
    public static authControllerGetAdminActions(): CancelablePromise<GetUserPermissionsEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/admin-actions',
        });
    }

    /**
     * @returns GetAdminPermissionsEntity Get all admmin permissions
     * @throws ApiError
     */
    public static authControllerGetAdminPermissions(): CancelablePromise<GetAdminPermissionsEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user-wallet/auth/admin-permissions',
        });
    }

}
